import React from 'react'
import { Box, styled } from '@mui/material'
import { Avatar } from '@/design-system'
import { isValidAvatarUrl } from '@/utils/helper'
import { avatarGradient } from '@/features/connections/utils'

const Wrap = styled(Box)({ position: 'relative', flexShrink: 0 })

const Halo = styled(Box)({
  position: 'absolute',
  inset: -16,
  borderRadius: '50%',
  background: 'var(--ds-gradient-spectrum)',
  filter: 'blur(22px)',
  opacity: 0.55,
  animation: 'profileHaloPulse 4200ms ease-in-out infinite',
  '@keyframes profileHaloPulse': {
    '0%, 100%': { opacity: 0.4, transform: 'scale(0.94)' },
    '50%': { opacity: 0.72, transform: 'scale(1.05)' },
  },
})

const Ring = styled(Box)({
  position: 'relative',
  borderRadius: '50%',
  padding: 4,
  background: 'var(--ds-gradient-spectrum)',
  flexShrink: 0,
})

export interface ProfileAvatarRingProps {
  name: string
  avatarUrl?: string
  size?: number
}

export function ProfileAvatarRing({ name, avatarUrl, size = 128 }: ProfileAvatarRingProps) {
  const initial = name[0]?.toUpperCase() ?? '?'
  const src = avatarUrl && isValidAvatarUrl(avatarUrl) ? avatarUrl : undefined

  return (
    <Wrap className='rise'>
      <Halo />
      <Ring
        sx={{
          width: size,
          height: size,
          boxShadow: '0 0 0 5px color-mix(in srgb, var(--ds-night-canvas) 50%, transparent), 0 12px 34px rgba(0,0,0,0.5)',
        }}
      >
        <Avatar
          src={src}
          sx={{
            width: '100%',
            height: '100%',
            fontSize: size * 0.33,
            fontWeight: 700,
            background: avatarGradient(name),
            color: 'var(--ds-accent-ink)',
            boxShadow: '0 0 0 4px color-mix(in srgb, var(--ds-night-canvas) 90%, transparent)',
          }}
        >
          {initial}
        </Avatar>
      </Ring>
    </Wrap>
  )
}
